export const VERSION = {
  PROD: 'V. 3.8.0',
  QA: 'V. 5.25.0 (QA)',
}
